import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    // KURAL: Eğer daha önce Gündüz moduna geçilmediyse, varsayılan olarak GECE MODU başlar
    const [isDark, setIsDark] = useState(() => {
        const stored = localStorage.getItem('isDark');
        return stored !== 'false';
    });

    const [brandTheme, setBrandTheme] = useState(() => localStorage.getItem('brandTheme') || 'default');
    const [navyTheme, setNavyTheme] = useState(() => localStorage.getItem('navyTheme') || 'default');

    useEffect(() => {
        const root = document.documentElement;

        // 1. Karanlık/Aydınlık mod sınıfını (class) html etiketine bas
        if (isDark) {
            root.classList.add('dark');
        } else {
            root.classList.remove('dark');
        }

        // 2. Renk ve Navy temalarını data- niteliği olarak bas
        root.setAttribute('data-brand', brandTheme);
        root.setAttribute('data-navy', navyTheme);

        // 3. Hafızaya kaydet
        localStorage.setItem('isDark', isDark);
        localStorage.setItem('brandTheme', brandTheme);
        localStorage.setItem('navyTheme', navyTheme);
    }, [isDark, brandTheme, navyTheme]);

    return (
        <ThemeContext.Provider value={{ isDark, setIsDark, brandTheme, setBrandTheme, navyTheme, setNavyTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useThemeCustomizer = () => useContext(ThemeContext);